import { Box, Dialog, DialogContent, DialogContentText, DialogTitle, Grid2, InputLabel, TextField, Typography, useMediaQuery, useTheme } from "@mui/material"
import MUIButton from "../../reusable_components/components/MUIButton"
import MUICancelButton from "../../reusable_components/components/MuiCancelButton"
import { Link, useLocation, useNavigate, useParams } from "react-router-dom"
import { useContext, useEffect, useState } from "react"
import * as Yup from 'yup'
import { yupResolver } from "@hookform/resolvers/yup"
import { Controller, useForm } from "react-hook-form"
import { useAddClientReferalMutation, useClientReferalApprovalMutation, useViewClientReferalByIdMutation } from "../../redux/clientReferences/clientReferences.api"
import { useSelector } from "react-redux"
import { SnackbarContext } from "../../reusable_components/components/Snackbar"
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const AddClientReferences = () => {

    const theme = useTheme()
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'))
    const navigate = useNavigate()
    const params = useParams()
    const location = useLocation()
    const { refId } = location?.state || ""
    const { Snackbar } = useContext(SnackbarContext)

    const { Profile } = useSelector((state) => state.common)

    const validationSchema = Yup.object().shape({
        address: Yup.string().required('Street/Building is Required'),
        city: Yup.string()
            .required('City is Required')
            .matches(/^[a-zA-Z\s]+$/, 'City should contain only letters'),
        clientContact: Yup.string()
            .required('Client Contact is Required')
            .matches(/^[a-zA-Z\s]+$/, 'Contact Person should contain only letters'),
        clientEmail1: Yup.string().email("Enter Valid Email").required("Please Enter the email")
            .test('Enter Valid Email', 'Enter Valid Email', (value) => {
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                return emailRegex.test(value);
            }),
        clientName: Yup.string()
            .required('Client Name is Required')
            .matches(/^[a-zA-Z0-9\s]+$/, 'Client Name should be Alphanumeric only'),
        clientPhone1: Yup.string()
            .required('Contact Number is Required'),
        country: Yup.string()
            .required('Country is Required')
            .matches(/^[a-zA-Z\s]+$/, 'Country should contain only letters'),
        opportunityDetails: Yup.string()
            .required('Opportunity Details is Required'),
        pincode: Yup.string()
            .required('Pincode is Required')
            .matches(/^[a-zA-Z0-9]+$/, 'Pincode should be Alphanumeric only'),
        state: Yup.string()
            .required('State is Required')
            .matches(/^[a-zA-Z\s]+$/, 'State should contain only letters'),
        website: Yup.string().required('Website is Required'),
    })

    const resolver = yupResolver(validationSchema)

    const {
        control,
        handleSubmit,
        formState: { errors },
        reset
    } = useForm({
        mode: 'onChange',
        resolver: resolver,
        defaultValues: {
            address: "",
            city: "",
            clientContact: "",
            clientEmail1: "",
            clientName: "",
            clientPhone1: "",
            country: "",
            opportunityDetails: "",
            pincode: "",
            state: "",
            website: ""
        }
    })

    const [alternateNumber, setAlternateNumber] = useState("")
    const [alternateEmail, setAlternateEmail] = useState("")
    const [clientNameValErr, setClientNameValErr] = useState("")
    const [stateValErr, setStateValErr] = useState("")
    const [countryValErr, setCountryValErr] = useState("")
    const [contactNoValErr, setContactNoValErr] = useState("")
    const [contactPersonValErr, setContactPersonValErr] = useState("")
    const [cityValErr, setCityValErr] = useState("")
    const [pincodeValErr, setPincodeErr] = useState("")
    const [reasonforRej, setReasonForRej] = useState("")
    const [status, setStatus] = useState("")
    const [open, setOpen] = useState(false)
    const [mode, setMode] = useState("")

    useEffect(() => {
        if (params?.id) {
            setMode('Admin ClientRef')
        } else if (location?.pathname?.includes('/edit-clientref')) {
            setMode('Edit ClientRef')
        } else {
            setMode('Add ClientRef')
        }
    }, [location?.pathname, params?.id])

    const handleOpen = () => {
        setOpen(true)
    }

    const handleClose = () => {
        setOpen(false)
        setReasonForRej("")
    }

    const [AddClientReferal] = useAddClientReferalMutation()
    const [ViewClientReferalById, { data: bindingClientRefDetails }] = useViewClientReferalByIdMutation()
    const [clientReferalApproval] = useClientReferalApprovalMutation()

    const editScreen = +params?.id
    useEffect(() => {
        try {
            const referalId = editScreen ? editScreen : (Profile?.profile?.role === 'recruiter' ? refId : null)

            if (referalId) {
                ViewClientReferalById({ referalId })
            }
        } catch (err) {
            Snackbar('Network error', 'error')
        }
    }, [editScreen, ViewClientReferalById])

    useEffect(() => {
        if (bindingClientRefDetails) {
            const defaultValues = {
                address: bindingClientRefDetails?.response?.data[0]?.address1,
                city: bindingClientRefDetails?.response?.data[0]?.address1,
                clientContact: bindingClientRefDetails?.response?.data[0]?.clientContact,
                clientEmail1: bindingClientRefDetails?.response?.data[0]?.clientEmail1,
                clientEmail2: bindingClientRefDetails?.response?.data[0]?.clientEmail2,
                clientName: bindingClientRefDetails?.response?.data[0]?.clientName,
                clientPhone1: bindingClientRefDetails?.response?.data[0]?.clientPhone1,
                clientPhone2: bindingClientRefDetails?.response?.data[0]?.clientPhone2,
                country: bindingClientRefDetails?.response?.data[0]?.country,
                opportunityDetails: bindingClientRefDetails?.response?.data[0]?.opportunityDetails,
                pincode: bindingClientRefDetails?.response?.data[0]?.pincode,
                state: bindingClientRefDetails?.response?.data[0]?.state,
                status: bindingClientRefDetails?.response?.data[0]?.status,
                website: bindingClientRefDetails?.response?.data[0]?.website
            }

            reset({
                ...defaultValues
            })

            setAlternateNumber(defaultValues?.clientPhone2)
            setAlternateEmail(defaultValues?.clientEmail2)
            setStatus(defaultValues?.status)
        }
    }, [bindingClientRefDetails])

    const handleAlternateNumber = (e) => {
        const value = e.target.value
        setAlternateNumber(value)
    }

    const handleAlternateEmail = (e) => {
        const value = e.target.value
        setAlternateEmail(value)
    }

    const handleReasonForRejChange = (e) => {
        const value = e.target.value
        setReasonForRej(value)
    }

    const onSubmit = async (data) => {
        try {
            const isRecrutier = Profile?.profile?.role === 'recruiter'
            const referalId = isRecrutier ? refId : ""

            const payload = {
                address: data?.address,
                alternateEmail: alternateEmail || "",
                alternatePhone: alternateNumber || "",
                city: data?.city,
                clientContact: data?.clientContact,
                clientEmail1: data?.clientEmail1,
                clientName: data?.clientName,
                clientPhone1: data?.clientPhone1,
                country: data?.country,
                opportunityDetails: data?.opportunityDetails,
                pincode: data?.pincode,
                referalId: referalId,
                state: data?.state,
                website: data?.website
            }

            const response = await AddClientReferal(payload).unwrap()
            if (response?.status === 200) {
                if (referalId) {
                    Snackbar('The client referal details has been updated successfully', 'success')
                } else {
                    Snackbar("Data Saved Sucessfully", 'success')
                }
                navigate('/client-ref')
            } else if (response?.status === 'error') {
                Snackbar(response?.data?.error_message, 'error')
            }
        } catch (err) {
            Snackbar('Network error', 'error')
        }
    }

    const handleApproveClientReferal = async (status) => {
        try {
            const payload = {
                adminId: Profile?.profile?.id,
                reason: reasonforRej || "",
                referalId: editScreen,
                status: status
            }

            const response = await clientReferalApproval(payload).unwrap()
            if (response?.status === 200) {
                if (status === "Approved") {
                    Snackbar('Client referal has been Approved Successfully', 'success')
                } else if (status === 'Rejected') {
                    Snackbar('Client referal has been Rejected Successfully', 'success')
                }
                navigate('/client-ref')
            }
        } catch (err) {
            Snackbar('Network error', 'error')
        }
    }

    return (
        <Box className='container'>
            <Grid2 item sx={{ display: 'flex', alignItems: 'center', color: '#6941C6', gap: '4px', cursor: 'pointer', width: '40px', marginBottom: '20px' }} onClick={() => navigate('/client-ref')}>
                <ArrowBackIcon sx={{ fontSize: '17px' }} />
                <Typography sx={{ fontWeight: 600, fontSize: '14px' }}>Back</Typography>
            </Grid2>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Typography className="title" sx={{ marginLeft: '10%' }}>Client Referral Details</Typography>

                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Box className='formBox'>
                        <Grid2 container sx={{ display: 'flex', justifyContent: 'space-between', flexDirection: isSmallScreen && 'column' }}>
                            {/* Sub container 1 */}
                            <Grid2 item container rowGap={2} sx={{ display: !isSmallScreen ? 'flex' : "", justifyContent: 'space-between', flexDirection: isSmallScreen && 'column' }}>
                                <Grid2 item sx={{ alignItems: "center", width: !isSmallScreen ? '40%' : '100%' }}>
                                    <InputLabel className="inputlabels"> Client Name <span style={{ color: 'red' }}>*</span></InputLabel>
                                    <div style={{ width: '100%' }}>
                                        <Controller
                                            control={control}
                                            name={"clientName"}
                                            render={({ field }) => (
                                                <TextField
                                                    {...field}
                                                    className="textfields"
                                                    placeholder="Enter Client Name"
                                                    sx={{
                                                        "& .MuiFormHelperText-root": {
                                                            color: errors?.clientName ? "red" : "inherit",
                                                            marginLeft: '-1px'
                                                        },
                                                    }}
                                                    helperText={errors?.clientName ? errors?.clientName?.message : ""}
                                                    disabled={params?.id}
                                                />
                                            )}
                                        />
                                    </div>
                                </Grid2>

                                <Grid2 item sx={{ alignItems: "center", width: !isSmallScreen ? '40%' : '100%' }}>
                                    <InputLabel className="inputlabels"> Street/Building <span style={{ color: 'red' }}>*</span></InputLabel>
                                    <Controller
                                        control={control}
                                        name={"address"}
                                        render={({ field }) => (
                                            <TextField
                                                {...field}
                                                className="textfields"
                                                placeholder="Enter Street/Building"
                                                sx={{
                                                    "& .MuiFormHelperText-root": {
                                                        color: errors?.address ? "red" : "inherit",
                                                        marginLeft: '-1px'
                                                    },
                                                }}
                                                helperText={errors?.address ? errors?.address?.message : ""}
                                                disabled={params?.id}
                                            />
                                        )}
                                    />
                                </Grid2>

                                <Grid2 item sx={{ alignItems: "center", width: !isSmallScreen ? '40%' : '100%' }}>
                                    <InputLabel className="inputlabels"> State <span style={{ color: 'red' }}>*</span></InputLabel>
                                    <div style={{ width: '100%' }}>
                                        <Controller
                                            control={control}
                                            name={"state"}
                                            render={({ field }) => (
                                                <TextField
                                                    {...field}
                                                    className="textfields"
                                                    placeholder="Enter State"
                                                    sx={{
                                                        "& .MuiFormHelperText-root": {
                                                            color: errors?.state ? "red" : "inherit",
                                                            marginLeft: '-1px'
                                                        },
                                                    }}
                                                    helperText={errors?.state ? errors?.state?.message : ""}
                                                    disabled={params?.id}
                                                />
                                            )}
                                        />
                                        {stateValErr !== "" && (
                                            <div style={{ color: 'red', fontSize: '0.8rem' }}>
                                                {stateValErr}
                                            </div>
                                        )}
                                    </div>
                                </Grid2>

                                <Grid2 item sx={{ alignItems: "center", width: !isSmallScreen ? '40%' : '100%' }}>
                                    <InputLabel className="inputlabels"> Country <span style={{ color: 'red' }}>*</span></InputLabel>
                                    <div style={{ width: '100%' }}>
                                        <Controller
                                            control={control}
                                            name={"country"}
                                            render={({ field }) => (
                                                <TextField
                                                    {...field}
                                                    className="textfields"
                                                    placeholder="Enter Country"
                                                    sx={{
                                                        "& .MuiFormHelperText-root": {
                                                            color: errors?.country ? "red" : "inherit",
                                                            marginLeft: '-1px'
                                                        },
                                                    }}
                                                    helperText={errors?.country ? errors?.country?.message : ""}
                                                    disabled={params?.id}
                                                />
                                            )}
                                        />
                                    </div>
                                </Grid2>

                                <Grid2 item sx={{ alignItems: "center", width: !isSmallScreen ? '40%' : '100%' }}>
                                    <InputLabel className="inputlabels"> Contact Number <span style={{ color: 'red' }}>*</span></InputLabel>
                                    <div style={{ width: '100%' }}>
                                        <Controller
                                            control={control}
                                            name={"clientPhone1"}
                                            render={({ field }) => (
                                                <TextField
                                                    {...field}
                                                    type="number"
                                                    className="textfields"
                                                    placeholder="Enter Contact Number"
                                                    sx={{
                                                        "& .MuiFormHelperText-root": {
                                                            color: errors?.clientPhone1 ? "red" : "inherit",
                                                            marginLeft: '-1px'
                                                        },
                                                    }}
                                                    helperText={errors?.clientPhone1 ? errors?.clientPhone1?.message : ""}
                                                    disabled={params?.id}
                                                />
                                            )}
                                        />
                                    </div>
                                </Grid2>

                                <Grid2 item sx={{ alignItems: "center", width: !isSmallScreen ? '40%' : '100%' }}>
                                    <InputLabel className="inputlabels"> Email <span style={{ color: 'red' }}>*</span></InputLabel>
                                    <Controller
                                        control={control}
                                        name={"clientEmail1"}
                                        render={({ field }) => (
                                            <TextField
                                                {...field}
                                                className="textfields"
                                                placeholder="Enter Email"
                                                sx={{
                                                    "& .MuiFormHelperText-root": {
                                                        color: errors?.clientEmail1 ? "red" : "inherit",
                                                        marginLeft: '-1px'
                                                    },
                                                }}
                                                helperText={errors?.clientEmail1 ? errors?.clientEmail1?.message : ""}
                                                disabled={params?.id}
                                            />
                                        )}
                                    />
                                </Grid2>
                            </Grid2>

                            {/* Sub container 2 */}
                            <Grid2 item container rowGap={2} sx={{ display: !isSmallScreen ? 'flex' : "", flexDirection: isSmallScreen && 'column', marginTop: '15px', justifyContent: 'space-between' }}>
                                <Grid2 item sx={{ alignItems: "center", width: !isSmallScreen ? '40%' : '100%' }}>
                                    <InputLabel className="inputlabels"> Contact Person <span style={{ color: 'red' }}>*</span></InputLabel>
                                    <div style={{ width: '100%' }}>
                                        <Controller
                                            control={control}
                                            name={"clientContact"}
                                            render={({ field }) => (
                                                <TextField
                                                    {...field}
                                                    className="textfields"
                                                    placeholder="Enter Contact Person"
                                                    sx={{
                                                        "& .MuiFormHelperText-root": {
                                                            color: errors?.clientContact ? "red" : "inherit",
                                                            marginLeft: '-1px'
                                                        },
                                                    }}
                                                    helperText={errors?.clientContact ? errors?.clientContact?.message : ""}
                                                    disabled={params?.id}
                                                />
                                            )}
                                        />
                                    </div>
                                </Grid2>

                                <Grid2 item sx={{ alignItems: "center", width: !isSmallScreen ? '40%' : '100%' }}>
                                    <InputLabel className="inputlabels"> City <span style={{ color: 'red' }}>*</span></InputLabel>
                                    <div style={{ width: '100%' }}>
                                        <Controller
                                            control={control}
                                            name={"city"}
                                            render={({ field }) => (
                                                <TextField
                                                    {...field}
                                                    className="textfields"
                                                    placeholder="Enter City"
                                                    sx={{
                                                        "& .MuiFormHelperText-root": {
                                                            color: errors?.city ? "red" : "inherit",
                                                            marginLeft: '-1px'
                                                        },
                                                    }}
                                                    helperText={errors?.city ? errors?.city?.message : ""}
                                                    disabled={params?.id}
                                                />
                                            )}
                                        />
                                    </div>
                                </Grid2>

                                <Grid2 item sx={{ alignItems: "center", width: !isSmallScreen ? '40%' : '100%' }}>
                                    <InputLabel className="inputlabels"> Pincode <span style={{ color: 'red' }}>*</span></InputLabel>
                                    <div style={{ width: '100%' }}>
                                        <Controller
                                            control={control}
                                            name={"pincode"}
                                            render={({ field }) => (
                                                <TextField
                                                    {...field}
                                                    className="textfields"
                                                    placeholder="Enter Pincode"
                                                    sx={{
                                                        "& .MuiFormHelperText-root": {
                                                            color: errors?.pincode ? "red" : "inherit",
                                                            marginLeft: '-1px'
                                                        },
                                                    }}
                                                    helperText={errors?.pincode ? errors?.pincode?.message : ""}
                                                    disabled={params?.id}
                                                />
                                            )}
                                        />
                                    </div>
                                </Grid2>

                                <Grid2 item sx={{ alignItems: "center", width: !isSmallScreen ? '40%' : '100%' }}>
                                    <InputLabel className="inputlabels"> Website Name <span style={{ color: 'red' }}>*</span></InputLabel>
                                    <Controller
                                        control={control}
                                        name={"website"}
                                        render={({ field }) => (
                                            <TextField
                                                {...field}
                                                className="textfields"
                                                placeholder="Enter Website Name"
                                                sx={{
                                                    "& .MuiFormHelperText-root": {
                                                        color: errors?.website ? "red" : "inherit",
                                                        marginLeft: '-1px'
                                                    },
                                                }}
                                                helperText={errors?.website ? errors?.website?.message : ""}
                                                disabled={params?.id}
                                            />
                                        )}
                                    />
                                </Grid2>

                                <Grid2 item sx={{ alignItems: "center", width: !isSmallScreen ? '40%' : '100%' }}>
                                    <InputLabel className="inputlabels"> Alternate Number</InputLabel>
                                    <TextField
                                        className="textfields"
                                        placeholder="Enter Alternate Number"
                                        value={alternateNumber}
                                        onChange={handleAlternateNumber}
                                        disabled={params?.id}
                                    />
                                </Grid2>

                                <Grid2 item sx={{ alignItems: "center", width: !isSmallScreen ? '40%' : '100%' }}>
                                    <InputLabel className="inputlabels"> Alternate Email </InputLabel>
                                    <TextField
                                        className="textfields"
                                        placeholder="Enter Alternate Email"
                                        value={alternateEmail}
                                        onChange={handleAlternateEmail}
                                        disabled={params?.id}
                                    />
                                </Grid2>
                            </Grid2>
                        </Grid2>
                        <Grid2 item sx={{ alignItems: "center", width: '100%', marginTop: '15px' }}>
                            <InputLabel className="inputlabels"> Opportunity Details<span style={{ color: 'red' }}>*</span> </InputLabel>
                            <div style={{ width: '100%' }}>
                                <Controller
                                    control={control}
                                    name={"opportunityDetails"}
                                    render={({ field }) => (
                                        <textarea
                                            {...field}
                                            className="jobPostingTextAreas"
                                            style={{ width: '100%', cursor: params?.id && 'not-allowed', height: '70px' }}
                                            placeholder="Enter Opportunity Details"
                                            disabled={params?.id}
                                        />
                                    )}
                                />
                                {errors?.opportunityDetails && (
                                    <div style={{ color: 'red', fontSize: '0.8rem' }}>
                                        {errors?.opportunityDetails?.message}
                                    </div>
                                )}
                            </div>
                        </Grid2>

                        <Grid2 item>
                            <Dialog
                                open={open}
                                onClose={handleClose}
                                sx={{
                                    "& .MuiDialog-paper": {
                                        minHeight: '50vh',
                                        minWidth: '45vw'
                                    }
                                }}
                                maxWidth='md'
                                scroll="paper"
                            >
                                <DialogTitle variant='h6'>Recruiter Rejection</DialogTitle>
                                <DialogContent dividers>
                                    <DialogContentText>
                                        <InputLabel className="inputlabels">Reason for Rejection <span style={{ color: 'red' }}>*</span></InputLabel>
                                        <textarea
                                            value={reasonforRej}
                                            onChange={handleReasonForRejChange}
                                            placeholder="Enter Reason"
                                            className="jobPostingTextAreas"
                                            style={{ width: '100%', minHeight: '100px' }}
                                        />
                                    </DialogContentText>

                                    <Grid2 item sx={{ display: 'flex', justifyContent: 'flex-end', gap: '20px' }}>
                                        <MUIButton title='Reject'
                                            sx={{
                                                backgroundColor: '#CC0000',
                                                "&:disabled": {
                                                    backgroundColor: '#fd5c63'
                                                }
                                            }}
                                            onClick={() => handleApproveClientReferal('Rejected')}
                                            disabled={!reasonforRej}
                                        />
                                        <MUICancelButton title='Cancel' onClick={handleClose} />
                                    </Grid2>
                                </DialogContent>
                            </Dialog>
                        </Grid2>
                    </Box>
                </Box>

                <Grid2 item sx={{ display: 'flex', justifyContent: 'flex-end', gap: '20px', marginTop: '15px' }}>
                    <MUICancelButton title='Cancel' component={Link} to='/client-ref' />
                    {!params?.id && (
                        <MUIButton title={mode === 'Add ClientRef' ? 'Save Changes' : 'Update'} type='submit' sx={{ backgroundColor: '#7F56D9', borderRadius: '7px', width: '130px' }} />
                    )}

                    {status?.toLowerCase() === 'pending' && params?.id && (
                        <>
                            <MUIButton title='Reject' onClick={() => handleOpen('Rejected')} sx={{ backgroundColor: '#FFF4ED', border: '1px solid #FFD6AE', color: '#D92D20', width: '110px' }} />
                            <MUIButton title='Approve' onClick={() => handleApproveClientReferal('Approved')} sx={{ backgroundColor: '#ECFDF3', border: '1px solid #ABEFC6', color: '#067647', width: '110px' }} />
                        </>
                    )}
                </Grid2>
            </form>
        </Box>
    )
}

export default AddClientReferences